const hy = {
  description: `Ամենամեծ անվճար հավաքածուն
կոգնիտիվ հակումների (մտածողության
օրինաչափություններ) ավելի քան
1000 կիրառության օրինակներով:`,
};
export default hy;
